import MuiAppBar from '@mui/material/AppBar';
import { styled, useTheme } from '@mui/material/styles';
import * as React from 'react';

import MenuToolbar from './MenuToolbarHeader';
import SlideBarMenu from './SlideBarMenu';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  /*transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),*/
  ...(open && {
    // marginLeft: drawerWidth,
    width: `100%`,
    /*transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),*/
  }),
}));

export default function DrawerMenu() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  const handleDrawer = () => setOpen(!open);

  return (
    <>
      <AppBar position="fixed" open={open} sx={{background: 'white'}}>
        <MenuToolbar handleDrawer={handleDrawer} open={open}/>
      </AppBar>
      
      <SlideBarMenu open={open} setOpen={setOpen} settingsOpen={settingsOpen} setSettingsOpen={setSettingsOpen}/>
    </>
  );
}

/*
 {auth && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
                edge="end"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Profile</MenuItem>
                <MenuItem onClick={handleClose}>Logout</MenuItem>
              </Menu>
            </div>
          )}

*/